import { render, staticRenderFns } from "./ModifyPasswordForm.vue?vue&type=template&id=645f83d4&scoped=true"
import script from "./ModifyPasswordForm.vue?vue&type=script&lang=js"
export * from "./ModifyPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./ModifyPasswordForm.vue?vue&type=style&index=0&id=645f83d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645f83d4",
  null
  
)

export default component.exports